import { schema } from "normalizr";

const PurchaseOrderHistorySchema = new schema.Entity("purchaseOrderHistories");
const PurchaseOrderHistoryArraySchema = new schema.Array(PurchaseOrderHistorySchema);

export { PurchaseOrderHistorySchema, PurchaseOrderHistoryArraySchema };